import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CorePopupComponent } from '../../../../../../../../ui-components/core-popup/core-popup.component';
import {
  validateTaxNo10,
  validateTCKN,
  validateTRPhone10,
} from '../../../../../../../../shared/services/validators/validateTCKN';
import { IPatient } from '../../../../../../../definition/patient/interface/patient.interface';
import { PatientCardComponent } from '../../../../../../../../shared/components/patient-card/patient-card.component';
import { InstituationService } from '../../../../../../../instituation/services/institiuation.service';
import { Option } from '../../../../../../../../ui-components/core-dropdown/core-dropdown.component';
import { Subject, takeUntil } from 'rxjs';
import {
  CasePaymentReceiver,
  PaymentReceiverEnum,
} from '../../../../interfaces/case-card-interfaces';
import { CaseService } from '../../../../../../services/case.services';
import { AppMessageService } from '../../../../../../../../shared/services/app-message/app-message.service';
import { AppAlertService } from '../../../../../../../../shared/services/app-alert/app-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { SaveIntituationPopupComponent } from './save-intituation-popup/save-intituation-popup.component';

@Component({
  selector: 'app-create-payment-receiver-popup',
  templateUrl: './create-payment-receiver-popup.component.html',
  styleUrl: './create-payment-receiver-popup.component.scss',
})
export class CreatePaymentReceiverPopupComponent implements OnInit, OnDestroy {
  @ViewChild('formPopup') formPopup: CorePopupComponent;
  @ViewChild('patientCard') patientCard: PatientCardComponent;
  @ViewChild('instCreatePopup') instCreatePopup: SaveIntituationPopupComponent;
  
  saveInstitutionId: number | undefined;

  type: PaymentReceiverEnum = PaymentReceiverEnum.PERSON;
  receiverForm!: FormGroup;
  initilizeData: CasePaymentReceiver = {
    type: PaymentReceiverEnum.PERSON,
    patientNo: null,
    tckn: null,
    fullName: null,
    institutionNo: null,
    institutionName: null,
    taxOffice: null,
    taxNo: null,
    phone: null,
    email: null,
    address: null,
    saveInstitution: false
  };
  institutions: Option[] = [];
  isSubmit: boolean = false;
  private readonly destroy$ = new Subject<void>();
  caseId: number;
  paymentReceiverId: number | null;
  loading: boolean = false;
  constructor(
    private readonly fb: FormBuilder,
    private readonly insService: InstituationService,
    private readonly caseService: CaseService,
    private readonly messageService: AppMessageService,
    private readonly appAlertService: AppAlertService,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit() {
    this.receiverForm = this.fb.group({
      type: [this.type],
      patientNo: [null],
      tckn: [null, [Validators.pattern(/^\d{11}$/)]],
      fullName: [null],
      phone: [null],
      email: [null],
      address: [null],
      description: [null],
      institutionNo: [null],
      institutionName: [null],
      taxOffice: [null],
      taxNo: [null],
      saveInstitution: [false]
    });

    const ctrl = this.receiverForm.get('institutionNo');

    const saveInstitutionCtrl = this.receiverForm.get('saveInstitution');
    if (ctrl?.value === null || !ctrl?.value) {
      saveInstitutionCtrl?.enable();
    } else {
      saveInstitutionCtrl?.disable();
      saveInstitutionCtrl?.setValue(false);
    }
    ctrl?.valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe((val: number | null) => {
    if (val === null || !val) {
      saveInstitutionCtrl?.enable();
    } else {
      saveInstitutionCtrl?.disable();
      saveInstitutionCtrl?.setValue(false);
    }
    
    this.onInstitutionChange(val);
  });

    this.insService.getAll().subscribe({
      next: (res) => {
        this.institutions =
          res?.map((e) => ({
            label: e?.signboard,
            value: e?.id,
            disabled: !e?.isActive,
            rows: { ...e },
          })) ?? [];
      },
    });
  }

  initilize(caseId: number) {
    this.caseId = caseId;
    this.paymentReceiverId = null;
    this.loading = true;
    this.caseService.getCasePaymentReceiver(this.caseId).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.item) {
          const item = {
            ...res.item,
            patientNo: res?.item?.patient?.id ?? null,
            institutionNo: res?.item?.institution?.id ?? null,
          };
          this.paymentReceiverId = item?.id ?? null;
          delete item.patient;
          delete item.institution;
          this.type = item.type;
          this.receiverForm.patchValue(
            {
              ...item,
            },
            { emitEvent: false } //  valueChanges tetiklenmemeli yoksa ngOninitteki listener tetiklenir
          );

          if (item.patientNo) {
            setTimeout(() => {
              this.patientCard?.setPatientValue(item.patientNo);
            }, 20);
          }
        } else {
          this.receiverForm.patchValue({
            ...this.initilizeData,
          });
        }
        this.applyValidatorsForMode(this.type);
        this.formPopup.openDialog();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  setMode(m: any) {
    if (this.type === m) return;
    this.type = m;
    this.receiverForm.get('type')!.setValue(m);
    this.applyValidatorsForMode(m);
  }

  isInvalid(name: string, errorKey?: string) {
    const c = this.receiverForm.get(name);
    if (!c) return false;

    const show = this.isSubmit || c.touched || c.dirty; // submit'te ya da dokunulmuşsa göster
    if (!show) return false;

    return errorKey ? c.hasError(errorKey) : c.invalid;
  }

  onPatientSelect(patient: IPatient) {
    if (patient) {
      const phones = patient?.contacts?.filter((c) => c.phone);
      const phone =
        phones.find((e) => e.priority)?.phone ??
        phones.find((e) => e.phone)?.phone ??
        null;

      const emails = patient?.contacts?.filter((c) => c.email);
      const email =
        emails.find((e) => e.priority)?.email ??
        emails.find((e) => e.email)?.email ??
        null;
      const addresses = patient?.addresses ?? [];
      const address =
        addresses.find((e) => e?.isPriority)?.formattedAddress ??
        addresses.find((e) => e.formattedAddress)?.formattedAddress ??
        null;

      this.receiverForm.patchValue({
        fullName: (patient?.firstName ?? '') + ' ' + (patient?.lastName + ''),
        patientNo: patient?.id ?? null,
        tckn: patient?.idNumber ?? null,
        phone: phone,
        email: email,
        address: address,
      });
      if (patient?.id != null) {
        this.patientCard.setPatientValue(patient.id);
      }
    } else {
      this.receiverForm.patchValue({
        fullName: null,
        patientNo: null,
        tckn: null,
        phone: null,
        email: null,
        address: null,
      });
    }
    this.checkPatientInstutionValueDisable();
  }

  onNewInstituationSaved(event: any) {
    if (event?.institutionId) {
      this.saveInstitutionId = event?.institutionId

      //  this.insService.getAll().subscribe({
      //   next: (res) => {
      //     this.institutions =
      //       res?.map((e) => ({
      //         label: e?.signboard,
      //         value: e?.id,
      //         disabled: !e?.isActive,
      //         rows: { ...e },
      //       })) ?? [];
      //   },

      // });
    }
  }
  saveReceiver() {
    this.isSubmit = true;
    if ((this.receiverForm.invalid || !this.checkValidationSimple()) && this.isSubmit) {
      this.receiverForm.markAllAsTouched();
      return;
    }

    const raw = this.receiverForm.getRawValue();

    if (this.type === PaymentReceiverEnum.INSTITUTION && !raw.institutionNo && raw.saveInstitution) {
      // Popup açılır ve kaydedildiğinde saved EventEmitter ile devam eder
      this.instCreatePopup.saved.subscribe((event: any) => {
        if (event?.institutionId) {
          this.saveInstitutionId = event.institutionId;
          this.sendReceiverPayload(raw);
        }
      });

      this.instCreatePopup.openDialog(raw);
      return; // popup açıkken devam etmesin
    }

    // Popup gerek yoksa direkt gönder
    this.sendReceiverPayload(raw);
  }

  private sendReceiverPayload(raw: any) {
    const payload =
      this.type === PaymentReceiverEnum.PERSON
        ? {
          type: PaymentReceiverEnum.PERSON,
          patientNo: raw.patientNo ?? null,
          tckn: (raw.tckn ?? '').toString().trim(),
          fullName: (raw.fullName ?? '').toString().trim(),
          phone: (raw.phone ?? '').toString().trim(),
          email: (raw.email ?? '').toString().trim(),
          address: (raw.address ?? '').toString().trim(),
          description: raw.description ?? null,
          institutionNo: null,
          institutionName: null,
          taxOffice: null,
          taxNo: null,
          saveInstitution: false
        }
        : {
          type: PaymentReceiverEnum.INSTITUTION,
          institutionNo: raw?.saveInstitution ? this.saveInstitutionId : (raw?.institutionNo ?? null),
          institutionName: (raw.institutionName ?? '').toString().trim(),
          taxOffice: (raw.taxOffice ?? '').toString().trim(),
          taxNo: (raw.taxNo ?? '').toString().trim(),
          phone: (raw.phone ?? '').toString().trim(),
          email: (raw.email ?? '').toString().trim(),
          address: (raw.address ?? '').toString().trim(),
          description: raw.description ?? null,
          patientNo: null,
          tckn: null,
          fullName: null,
        };

    this.caseService.setPaymentReceiverForCase(payload as CasePaymentReceiver, this.caseId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.messageService.successToast(
              this.translateService.instant('case-payment-receiver.success-save'),
              ''
            );
            this.formPopup.closeDialog();
          }
        }
      });
  }


  deletePopup() {
    this.appAlertService.sweetConfirm({
      header: this.translateService.instant(
        'case-payment-receiver.delete-header'
      ),
      message: this.translateService.instant(
        'case-payment-receiver.delete-text'
      ),
      showCloseButton: true, 
      accept: () => {
        this.caseService.deleteCasePaymentReceiver(this.caseId).subscribe({
          next: (res) => {
            if (res.success) {
              this.messageService.successToast(
                this.translateService.instant(
                  'case-payment-receiver.delete-success'
                ),
                ''
              );
              this.formPopup.closeDialog();
            }
          },
        });
      },
    });
  }

  onlyDigit(evt: KeyboardEvent) {
    const ch = evt.key;
    if (!/^\d{11}$/.test(ch)) evt.preventDefault();
  }

  onInstitutionChange(institutionNo: number | null) {
    const institution: any = this.institutions.find(
      (e) => e.value === institutionNo
    );

    if (institution) {
      const institutionName =
        institution?.rows?.signboard || institution?.rows?.title || null;
      const taxOffice = institution?.rows?.taxOffice ?? null;
      const taxNo =
        this.onlyDigits(institution?.rows?.taxNumber)?.slice(0, 10) ?? null;
      const address = institution?.rows?.address?.formattedAddress ?? null;
      const phones = institution?.rows?.contacts?.filter((c: any) => c?.phone);
      const phone =
        phones.find((e: any) => e.priority)?.phone ??
        phones.find((e: any) => e.phone)?.phone ??
        null;
      this.receiverForm.patchValue({
        institutionName,
        taxNo: taxNo,
        taxOffice: taxOffice,
        address: address,
        phone: phone,
      });
    } else {
      this.receiverForm.patchValue({
        institutionName: null,
        taxNo: null,
        taxOffice: null,
        address: null,
        phone: null,
      });
    }
    this.checkPatientInstutionValueDisable();
  }

  onClose() {
    this.isSubmit = false;
    this.receiverForm.patchValue({ ...this.initilizeData });
  }
  private resetAllControls(): void {
    for (const key of Object.keys(this.receiverForm.controls)) {
      if (key === 'type') continue;

      const control = this.receiverForm.get(key);
      if (!control) continue;

      control.clearValidators();
      control.disable({ emitEvent: false });
      control.updateValueAndValidity({ emitEvent: false });
    }
  }

  private enableFields(fields: string[]): void {
    for (const f of fields) {
      this.receiverForm.get(f)?.enable({ emitEvent: false });
    }
  }

  private disableFields(fields: string[]): void {
    for (const f of fields) {
      this.receiverForm.get(f)?.disable({ emitEvent: false });
    }
  }

  private setValidators(fields: Record<string, any[]>): void {
    for (const [key, validators] of Object.entries(fields)) {
      this.receiverForm.get(key)?.setValidators(validators);
    }
  }

  private applyValidatorsForMode(mode: PaymentReceiverEnum) {

    this.resetAllControls();

    if (mode === PaymentReceiverEnum.PERSON) {

      this.setValidators({
        tckn: [Validators.required, validateTCKN],
        fullName: [Validators.required],
        phone: [Validators.required, validateTRPhone10],
        email: [Validators.required, Validators.email],
        address: [Validators.required],
      });

      this.enableFields([
        'patientNo', 'tckn', 'fullName', 'phone', 'email', 'address', 'description'
      ]);

    } else {

      this.setValidators({
        institutionName: [Validators.required],
        taxOffice: [Validators.required],
        taxNo: [Validators.required, validateTaxNo10],
        phone: [Validators.required, validateTRPhone10],
        email: [Validators.required, Validators.email],
        address: [Validators.required],
      });

      this.enableFields([
        'institutionNo', 'institutionName', 'taxOffice', 'taxNo',
        'phone', 'email', 'address', 'description'
      ]);
    }

    this.receiverForm.updateValueAndValidity({ emitEvent: false });
    this.checkPatientInstutionValueDisable();
  }


  private checkPatientInstutionValueDisable(): void {

    if (this.type === PaymentReceiverEnum.PERSON) {

      const fields = ['fullName', 'personNo', 'tckn', 'phone', 'email', 'address'];
      const hasPatient = !!this.receiverForm.get('patientNo')?.value;

      hasPatient ? this.disableFields(fields) : this.enableFields(fields);

    } else {

      const fields = ['institutionName', 'taxOffice', 'taxNo', 'address', 'phone'];
      const hasInstitution = !!this.receiverForm.get('institutionNo')?.value;

      hasInstitution ? this.disableFields(fields) : this.enableFields(fields);
    }

    this.receiverForm.updateValueAndValidity({ emitEvent: false });
  }

  private onlyDigits(v: any): string | null {
    if (!v) return null;
    const d = String(v).replaceAll(/\D/g, '');
    return d || null;
  }

  onlyDigitTCKN(event: KeyboardEvent): boolean {
    const key = event.key;
    // Eğer basılan tuş 0-9 arasında değilse, engelle
    if (!/^\d$/.test(key))  {
      event.preventDefault();
      return false;
    }

    return true;
  }


  checkValidationSimple(): boolean {
    const raw = this.receiverForm.getRawValue(); // disabled dahil okur
    const mode: PaymentReceiverEnum = this.type ?? raw.type ?? 'PERSON';

    // ZORUNLU ALAN LİSTELERİ (patientNo / institutionNo artık zorunlu DEĞİL)
    const required =
      mode === 'PERSON'
        ? (['tckn', 'fullName', 'phone', 'email', 'address'] as const)
        : ([
            'institutionName',
            'taxOffice',
            'taxNo',
            'phone',
            'email',
            'address',
          ] as const);

    // Zorunlu alan boş mu?
    const missing = required.filter((k) => !this.isFilled(raw[k]));

    // FORMAT kontrolleri (opsiyonel değil; doluysa kontrol et)
    const invalid: string[] = [];
    // email
    if (
      this.isFilled(raw.email) &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw.email)
    )
      invalid.push('email');
    // phone: 10 hane digit (maskelenmiş giriş kullanıyorsun, modele 10 hane rakam geliyor)
    if (
      this.isFilled(raw.phone) &&
      !!validateTRPhone10({ value: raw.phone } as any)
    )
      invalid.push('phone');

    if (mode === 'PERSON') {
      if (this.isFilled(raw.tckn) && !!validateTCKN({ value: raw.tckn } as any))
        invalid.push('tckn');
    } else if(this.isFilled(raw.taxNo) &&
        !!validateTaxNo10({ value: raw.taxNo } as any)) {
     
        invalid.push('taxNo');
    }

    // Yalın sonuç
    return missing.length === 0 && invalid.length === 0;
  }

  private isFilled(v: any): boolean {
    return v !== null && v !== undefined && String(v).trim() !== '';
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  
}
